module.exports = __webpack_public_path__ + "public/files/img/table.d4f388a1.gif";